import { apiInstance } from '@api/WhisApi/whisApi.instance';
import { ConfigurationResponseDto } from '@api/WhisApi/configuration/configuration.types';

export const configurationApi = {
  get: (): Promise<ConfigurationResponseDto> => {
    return apiInstance<ConfigurationResponseDto>({
      url: '/configuration',
    });
  },
};
